/* @flow */
import * as React from 'react';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import MultilingualLanguages from 'components/MultilingualLanguages';
import Loading from 'components/Loading/Loading';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import UserStore from 'stores/UserStore';

import styles from './Multilingual.module.scss';

type InjectedProps = { userStore: UserStore } & TranslatorProps;

@translate()
@inject('userStore')
@observer
export default class Multilingual extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  @observable changeLanguageLoading = false;

  handleChangeLanguage = async (languageCode: string) => {
    this.changeLanguageLoading = true;
    const { userStore } = this.props;

    await userStore.updateUserLanguage(languageCode);
    this.changeLanguageLoading = false;
  };

  render() {
    const { userStore } = this.props;

    return (
      <div className={styles['multilingual-select']}>
        {this.changeLanguageLoading ? (
          <Loading variant="small" />
        ) : (
          <MultilingualLanguages
            languageCode={userStore.userLanguage}
            onChangeLanguage={languageCode => {
              this.handleChangeLanguage(languageCode);
            }}
          />
        )}
      </div>
    );
  }
}
